import { MessageCircle } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { SITE_COPY, whatsappLink } from "@/lib/siteContent";

export function WhatsAppFab() {
  const { lang } = useI18n();
  const label = SITE_COPY[lang].fab;

  return (
    <a
      href={whatsappLink(lang)}
      target="_blank"
      rel="noopener noreferrer nofollow"
      aria-label={label}
      title={label}
      className="fixed bottom-5 right-5 z-50 inline-flex h-14 w-14 items-center justify-center rounded-full bg-accent text-accent-foreground shadow-card transition hover:brightness-95 focus:outline-none focus:ring-2 focus:ring-ring md:bottom-7 md:right-7"
    >
      <MessageCircle className="h-6 w-6" />
    </a>
  );
}
